<!-- 了解你 -->
<template>
  <div style="height: 100%; background: #253746;">
    <Header></Header>
    <div class="know tc">
      <p class="fb tl f16 pt20 mL15">了解你</p>
      <div class="mb20 mt60 f16" style='text-align: left'>
        <span class="inline-block tl mL15 f14">年龄</span>
        <el-input v-model="age" placeholder="请输入年龄" type="text" size='mini'></el-input>
      </div>
<!--      <div class="mb20 f16">-->
<!--        <span class="inline-block tl">性别</span>-->
<!--&lt;!&ndash;        <el-input v-model="age" placeholder="请输入性别" type="text"></el-input>&ndash;&gt;-->
<!--        <el-select v-model="gender" placeholder="请输入性别">-->
<!--          <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
      <div class="mb20 f16" style='text-align: left'>
        <span class="inline-block tl mL15 f14">性别</span>
        <el-radio-group v-model="gender">
          <el-radio v-for="item in genderOptions" :key="item.value" :label="item.value">{{item.label}}</el-radio>
        </el-radio-group>
      </div>
      <div class="mb20 f16" style='text-align: left'>
        <span class="inline-block tl mL15 f14">已有储蓄规模</span>
        <el-input v-model="alreadyScaleSaving" placeholder="请输入已有储蓄规模" type="text" size='mini'></el-input>
      </div>
      <div class="mb20 taxSpend f16" style='text-align: left'>
        <span class="inline-block tl mL15 f14">税前收入</span>
        <el-select v-model="beforeTax" placeholder="月度" size='mini'>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-input v-model="preTaxIncome" placeholder="请输入税前收入" type="text" size='mini'></el-input>
      </div>
      <div class="mb20 taxSpend f16" style='text-align: left'>
        <span class="inline-block tl mL15 f14">其他收入</span>
        <el-select v-model="other" placeholder="月度" size='mini'>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-input v-model="otherIncome" placeholder="请输入税前收入" type="text" size='mini'></el-input>
      </div>
      <div class="mb20 taxSpend f16" style='text-align: left'>
        <span class="inline-block tl mL15 f14">预估支出</span>
        <el-select v-model="spending" placeholder="月度" size='mini'>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-input v-model="estimatedExpenses" placeholder="请输入预估支出" type="text" size='mini'></el-input>
      </div>
      <div class="tr" style="width:100%;margin: 20px auto"><el-button class="co-f mt20 mr20 base-bg base-border-color" @click="saveBaseInfo">下一步</el-button></div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Home',
  data () {
    return {
      age: '',
      gender: 'male',
      alreadyScaleSaving: '',
      preTaxIncome: '',
      otherIncome: '',
      estimatedExpenses: '',
      password: '',
      beforeTax: 'm',
      spending: 'm',
      other: 'm',
      genderOptions: [{'value':'male', 'label':'男'}, {'value':'female', 'label': '女'}],
      options: [{'value':'m', 'label':'月度'}, {'value':'y', 'label':'年度'}],
      getToken: ''
    }
  },
  components: { Header },
  computed: {
    token () {
      return this.$store.getters.getToken
    }
  },
  mounted () {
    this.getToken = this.token === '' ? localStorage.getItem('token') : this.token
   },
  methods: {
    saveBaseInfo () {
      const baseInfo = {
        'age': this.age,
        'alreadyScaleSaving': this.alreadyScaleSaving,
        'preTaxIncome': this.beforeTax === 'm' ? this.preTaxIncome : this.preTaxIncome / 12,
        'otherIncome': this.other === 'm' ? this.otherIncome : this.otherIncome / 12,
        'estimatedExpenses': this.spending === 'm' ? this.estimatedExpenses : this.estimatedExpenses / 12,
        'gender': this.gender
      }
      // const url = this.$api.BaseInfo
      // // // const url = this.$api.Info
      // const params = {
      //   "age": 50,
      //   "already_saving": 50000,
      //   "pre_tax_income": 10000,
      //   "estimated_expenses": 5000
      // }
      // this.$http.post(url, params, {Authorization: `Bearer ${this.getToken}`}, '', res => {
      //   console.log(res);
      //   this.$router.push({name: 'Result'})
      // })
      this.$router.push({name: 'KnowMore', params:baseInfo})
    }
  }
}
</script>

<style scoped>
.know{
   width: 80%;
   height: 490px;
   border-radius: 20px;
   background: #fff;
   margin: 80px auto;
}
.know >>> .inline-block{
  width: 30%;
  /*max-width: 150px;*/
}
.el-input{
  width: 55%;
  margin-right: 15px;
}
.el-radio-group{
  width: 60%;
  text-align: left;
}
.taxSpend .el-select{
  width: 20%;
}
.taxSpend .el-input{
  width: 30%;
  margin-left: 10px;
  margin-right: 15px;
}
.know .el-button{
  height: 30px;
  line-height: 0;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/KnowYou.vue